import { IJsonQuery } from '@cian/api-models/common/json_query';

import { setGeo } from './helpers';

export function clearGeo(jsonQuery: IJsonQuery): () => IJsonQuery {
  return () => setGeo()(jsonQuery)([]);
}
